const doc = [({"ko":({"adminComponentHotelWaitingList":({"hotelWaitingListIndexTitle":"공실 대기 목록"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;